import { render, staticRenderFns } from "./personList.vue?vue&type=template&id=5e259db0&scoped=true"
import script from "./personList.vue?vue&type=script&lang=js"
export * from "./personList.vue?vue&type=script&lang=js"
import style0 from "./personList.vue?vue&type=style&index=0&id=5e259db0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e259db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e259db0')) {
      api.createRecord('5e259db0', component.options)
    } else {
      api.reload('5e259db0', component.options)
    }
    module.hot.accept("./personList.vue?vue&type=template&id=5e259db0&scoped=true", function () {
      api.rerender('5e259db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/requirementAnalysis/comps/personList.vue"
export default component.exports